/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CertificationsService {
    /**
     * Get certifications with optional filters
     * Retrieves certifications with optional filtering by category, name, or type
     * @param category Filter by certification category
     * @param name Filter by certification name
     * @param type Filter by certification type (standard excludes diversity, diversity shows only diversity)
     * @returns any Certifications retrieved successfully
     * @throws ApiError
     */
    public static getApiV2Certifications(
        category?: string,
        name?: string,
        type: 'standard' | 'diversity' = 'standard',
    ): CancelablePromise<{
        status?: boolean;
        message?: string;
        data?: Array<{
            /**
             * Certification ID
             */
            id?: number;
            /**
             * Certification name
             */
            certname?: string;
            /**
             * Certification category
             */
            certcategory?: string;
            /**
             * Certification tier
             */
            tier?: string | null;
            /**
             * Certification description
             */
            description?: string | null;
            /**
             * Whether the certification is verified
             */
            verified?: boolean | null;
        }>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v2/certifications',
            query: {
                'category': category,
                'name': name,
                'type': type,
            },
        });
    }
    /**
     * Get certifications for a user
     * Retrieves certifications associated with a user through their locations
     * @param userId User ID
     * @returns any Certifications retrieved successfully
     * @throws ApiError
     */
    public static getApiV2UsersCertifications(
        userId: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v2/users/{userId}/certifications',
            path: {
                'userId': userId,
            },
            errors: {
                400: `User ID not provided`,
            },
        });
    }
}
